<script setup lang="ts">
const emit = defineEmits<{
  (e: 'click'): void;
}>();
</script>

<template>
  <button class="new-ride-button" @click="emit('click')">
    <span class="icon">+</span>
    <span class="text">Neue Mitfahrt</span>
  </button>
</template>

<style scoped>
.new-ride-button {
  position: fixed;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  background: #960040;
  color: white;
  border: none;
  border-radius: 24px;
  padding: 12px 24px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 100;
  transition: transform 0.2s, background-color 0.2s;
}

.new-ride-button:hover {
  background: #7d0035;
  transform: translateX(-50%) translateY(-2px);
}

.icon {
  font-size: 1.2rem;
  font-weight: bold;
}
</style>